/* global axios */
import ApiClient from './ApiClient';

class ArcAPI extends ApiClient {
  constructor() {
    super('arc', { accountScoped: true });
  }

  // Acesso / geral
  access() {
    return axios.get(`${this.url}/access`);
  }

  // ---- Painel do cliente ----
  overview() {
    return axios.get(`${this.url}/overview`);
  }

  panelDeliverables(params = {}) {
    return axios.get(`${this.url}/panel/deliverables`, { params });
  }

  panelKpis() {
    return axios.get(`${this.url}/panel/kpis`);
  }

  panelMeetings(params = {}) {
    return axios.get(`${this.url}/panel/meetings`, { params });
  }

  panelDecisions() {
    return axios.get(`${this.url}/panel/decisions`);
  }

  panelPendingItems(params = {}) {
    return axios.get(`${this.url}/panel/pending_items`, { params });
  }

  panelBadges() {
    return axios.get(`${this.url}/panel/badges`);
  }

  validateDeliverable(id) {
    return axios.patch(`${this.url}/panel/deliverables/${id}/validate`);
  }

  resolvePendingClient(id) {
    return axios.patch(`${this.url}/panel/pending_items/${id}/resolve`);
  }

  createKpiValueClient(id, payload) {
    return axios.post(`${this.url}/panel/kpis/${id}/values`, payload);
  }

  getJourney() {
    return axios.get(`${this.url}/journey`);
  }

  updateJourney(journey) {
    return axios.patch(`${this.url}/journey`, { journey });
  }

  cycles() {
    return axios.get(`${this.url}/journey/cycles`);
  }

  nextCycle() {
    return axios.post(`${this.url}/journey/next_cycle`);
  }

  applyTemplateUpdates() {
    return axios.post(`${this.url}/journey/apply_template_updates`);
  }

  // Entregas
  deliverables(params = {}) {
    return axios.get(`${this.url}/deliverables`, { params });
  }

  createDeliverable(deliverable) {
    return axios.post(`${this.url}/deliverables`, { deliverable });
  }

  updateDeliverable(id, deliverable, extra = {}) {
    return axios.patch(`${this.url}/deliverables/${id}`, { deliverable, ...extra });
  }

  deleteDeliverable(id) {
    return axios.delete(`${this.url}/deliverables/${id}`);
  }

  showDeliverable(id) {
    return axios.get(`${this.url}/deliverables/${id}`);
  }

  bulkUpdateDeliverables(payload) {
    return axios.post(`${this.url}/deliverables/bulk_update`, payload);
  }

  addDeliverablesFromTemplate(chaves) {
    return axios.post(`${this.url}/deliverables/add_from_template`, { chaves });
  }

  reorderDeliverables(ordem) {
    return axios.post(`${this.url}/deliverables/reorder`, { ordem });
  }

  // Indicadores
  kpis() {
    return axios.get(`${this.url}/kpis`);
  }

  createKpi(kpi) {
    return axios.post(`${this.url}/kpis`, { kpi });
  }

  updateKpi(id, kpi) {
    return axios.patch(`${this.url}/kpis/${id}`, { kpi });
  }

  deleteKpi(id) {
    return axios.delete(`${this.url}/kpis/${id}`);
  }

  saveKpiValues(id, values) {
    return axios.post(`${this.url}/kpis/${id}/values`, { values });
  }

  setKpiBaseline(id) {
    return axios.post(`${this.url}/kpis/${id}/set_baseline`);
  }

  // Valor gerado
  valueCategories() {
    return axios.get(`${this.url}/value_categories`);
  }

  createValueCategory(value_category) {
    return axios.post(`${this.url}/value_categories`, { value_category });
  }

  updateValueCategory(id, value_category) {
    return axios.patch(`${this.url}/value_categories/${id}`, { value_category });
  }

  deleteValueCategory(id) {
    return axios.delete(`${this.url}/value_categories/${id}`);
  }

  valueEntries(params = {}) {
    return axios.get(`${this.url}/value_entries`, { params });
  }

  createValueEntry(value_entry) {
    return axios.post(`${this.url}/value_entries`, { value_entry });
  }

  updateValueEntry(id, value_entry) {
    return axios.patch(`${this.url}/value_entries/${id}`, { value_entry });
  }

  deleteValueEntry(id) {
    return axios.delete(`${this.url}/value_entries/${id}`);
  }

  // Reuniões
  meetings(params = {}) {
    return axios.get(`${this.url}/meetings`, { params });
  }

  showMeeting(id) {
    return axios.get(`${this.url}/meetings/${id}`);
  }

  createMeeting(meeting) {
    return axios.post(`${this.url}/meetings`, { meeting });
  }

  updateMeeting(id, meeting) {
    return axios.patch(`${this.url}/meetings/${id}`, { meeting });
  }

  deleteMeeting(id) {
    return axios.delete(`${this.url}/meetings/${id}`);
  }

  regenerateMeetings() {
    return axios.post(`${this.url}/meetings/recurrence`);
  }

  addParticipant(meetingId, participant) {
    return axios.post(`${this.url}/meetings/${meetingId}/participants`, { participant });
  }

  updateParticipant(meetingId, id, participant) {
    return axios.patch(`${this.url}/meetings/${meetingId}/participants/${id}`, { participant });
  }

  removeParticipant(meetingId, id) {
    return axios.delete(`${this.url}/meetings/${meetingId}/participants/${id}`);
  }

  // Decisões
  decisions() {
    return axios.get(`${this.url}/decisions`);
  }

  createDecision(decision) {
    return axios.post(`${this.url}/decisions`, { decision });
  }

  updateDecision(id, decision) {
    return axios.patch(`${this.url}/decisions/${id}`, { decision });
  }

  deleteDecision(id) {
    return axios.delete(`${this.url}/decisions/${id}`);
  }

  // Pendências
  pendingItems(params = {}) {
    return axios.get(`${this.url}/pending_items`, { params });
  }

  createPendingItem(pending_item) {
    return axios.post(`${this.url}/pending_items`, { pending_item });
  }

  updatePendingItem(id, pending_item) {
    return axios.patch(`${this.url}/pending_items/${id}`, { pending_item });
  }

  resolvePendingItem(id) {
    return axios.patch(`${this.url}/pending_items/${id}/resolve`);
  }

  deletePendingItem(id) {
    return axios.delete(`${this.url}/pending_items/${id}`);
  }

  // Conquistas
  badges() {
    return axios.get(`${this.url}/badges`);
  }

  createBadge(badge) {
    return axios.post(`${this.url}/badges`, { badge });
  }

  updateBadge(id, badge) {
    return axios.patch(`${this.url}/badges/${id}`, { badge });
  }

  deleteBadge(id) {
    return axios.delete(`${this.url}/badges/${id}`);
  }

  grantBadge(id) {
    return axios.post(`${this.url}/badges/${id}/grant`);
  }

  revokeBadge(id, motivo) {
    return axios.post(`${this.url}/badges/${id}/revoke`, { motivo });
  }
}

export default new ArcAPI();
